var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      !_vm.miniLayout ? _c("Header") : _vm._e(),
      _vm.status === 200
        ? _c("router-view", { staticClass: "view" })
        : _c("ErrorPage", { attrs: { status: _vm.status } }),
      _vm.showToTop ? _c("to-top") : _vm._e(),
      _c("Footer", {
        attrs: {
          location: _vm.miniLayout ? "footer_menu_checkout" : "footer_menu"
        }
      }),
      !_vm.miniLayout ? _c("GlobalSearch") : _vm._e(),
      _c("QuickView"),
      _c("Notifications"),
      _c("auth-modal"),
      _c("city-modal"),
      _c("city-confirmation-modal"),
      _c("cookies-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }